import { useQuery } from '@tanstack/react-query';
import { makeBackendApi } from 'services/BackendApi';
import { ICompany } from 'services/BackendApi/types/CompaniesResponse';
import { sortBy } from 'lodash';

export const COMPANIES_QUERY_KEY = 'companies';

/**
 * React Query hook for fetching all companies (travel companies).
 * Returns companies sorted by name (case-insensitive) for use in dropdowns.
 *
 * @param enabled - Whether the query should be enabled (default: true)
 * @returns Query object with companies data
 */
export const useCompaniesQuery = (enabled: boolean = true) => {
  return useQuery({
    queryKey: [COMPANIES_QUERY_KEY],
    queryFn: async () => {
      const api = makeBackendApi();
      const response = await api.getCompanies({ skipSRAssignmentFilter: 'true' });
      // Sort companies by name (case-insensitive) for dropdown display
      const sortedCompanies = sortBy(
        response.data.data,
        (company: ICompany) => company.name?.toLowerCase() ?? ''
      );
      return sortedCompanies;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes - company list rarely changes
  });
};
